export { default as spinPromotion1 } from './spin_1.png';
